import { Box } from "@chakra-ui/react";
import React from "react";
import DynamicTable from "../../DynamicTable/DynamicTable";

export const Burden = ({ data, headers }) => {
  console.log(data, headers);
  return (
    <Box maxW="1150px" m="auto">
      <DynamicTable data={data || []} headers={headers} />
    </Box>
  );
};
